export default "__VITE_ASSET__P6T0PF11__"